import { render, staticRenderFns } from "./DeprecationBanner.vue?vue&type=template&id=2e1ce736&scoped=true&"
import script from "./DeprecationBanner.vue?vue&type=script&lang=js&"
export * from "./DeprecationBanner.vue?vue&type=script&lang=js&"
import style0 from "./DeprecationBanner.vue?vue&type=style&index=0&id=2e1ce736&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ce736",
  null
  
)

export default component.exports